import React, { useState } from 'react';
import Checkout from './Pages/Checkout';
import Landing from './Pages/Landing';
import biz from './Assets/BIZ.svg';
import logo from './Assets/logo-dona-mara.png';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.min.css'
import {
  Footer
} from './Atoms';
import ReactGA from "react-ga4";

//Google Analytics
const TRACKIND_ID = ("G-EHTZ1YV431")
ReactGA.initialize(TRACKIND_ID)

ReactGA.send({ hitType: "pageview", page: window.location.pathname });

function App() {
  const [openCheckout, setOpenCheckout] = useState();

  return (
    <div className="App">
      <div className="traced-header" />
      <img src={logo} className="App-logo" alt="logo" />
      {openCheckout && <Checkout plan={openCheckout} onCloseCheckout={setOpenCheckout} />}
      {!openCheckout && <Landing onOpenCheckout={setOpenCheckout} />}
      <Footer>
        <img src={biz} alt="Biz | simplesnologia" />
      </Footer>
    </div>
  );
}

export default App;
